import Vue from 'vue'
import VueRouter from 'vue-router'
import Authorized from './Authorized';
import store from './store';
import router from './routes';
import ElementUI from 'elementui-lts';
import 'elementui-lts/lib/theme-chalk/index.css';
import 'elementui-lts/lib/theme-chalk/display.css'
import locale from 'elementui-lts/lib/locale/lang/zh-TW'
import Sheet from './components/Sheet';
import './set';


Vue.config.productionTip = false;
Vue.use(ElementUI, {locale});
Vue.use(VueRouter);
Vue.component("Sheet", Sheet);


Vue.config.errorHandler = (err, vm, info) =>{
  console.error(err);
  console.error(vm);
  console.error(info);
};

new Vue({
  render: h => h(Authorized),
  router,
  store,
}).$mount('#app');
